import { env } from '@repo/env';
import { LinkType } from '@repo/segment/enums';
import { EntityPlacementCtaTypeEnum } from '@repo/supergraph/marketplace/enums';
import { CtaLink } from '@repo/ui-v2/CtaLink';
import { renderStructuredContent } from '../../rendererContext';
import type { LinkProps } from './types';

export function Link({
  props: { children, href, target, isWithinProductCardBottomLine = false, ctaData, rendererProps },
}: LinkProps) {
  return (
    <>
      {[children].flat().map((child, idx) => {
        // support empty string
        if (typeof child === 'string') {
          if (
            isWithinProductCardBottomLine &&
            href?.includes(`${env.NEXT_PUBLIC_NW_URL}/redirect/`) &&
            ctaData?.cta &&
            ctaData?.ctaAnalytics
          ) {
            // This logic will be removed by https://nerdwallet.atlassian.net/browse/BNK-812
            return (
              <CtaLink
                key={idx}
                cta={{
                  ...ctaData.cta,
                  type: EntityPlacementCtaTypeEnum.RestOfProductCard,
                }}
                monetizable={ctaData.ctaAnalytics.monetizable}
                analyticsPayload={{
                  ...ctaData.ctaAnalytics,
                }}
                linkType={LinkType.REST_OF_PRODUCT_CARD}
              >
                {child}
              </CtaLink>
            );
          }
          return (
            <a key={idx} href={href} target={target}>
              {child}
            </a>
          );
        }

        if (!child) {
          return null;
        }
        return (
          <a key={idx} href={href} target={target}>
            {renderStructuredContent(child, rendererProps)}
          </a>
        );
      })}
    </>
  );
}
